export default __webpack_public_path__ + "static/Survicate-14cbe633ff2b94a6c8774634ac606e2f.png";